<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <CRow class="justify-content-center">
                    <CIcon src="img/quickquiz-app-logo.jpg" height="60" width="60" alt="Logo"/>
                  </CRow>
                  <h5 class="text-center">Quick Quiz Admin</h5>
                  <CInput placeholder="Email" v-model="email">
                    <template #prepend-content>
                      <CIcon name="cil-user"/>
                    </template>
                  </CInput>
                  <CInput placeholder="Password" type="password" v-model="password">
                    <template #prepend-content>
                      <CIcon name="cil-lock-locked"/>
                    </template>
                  </CInput>
                  <CRow>
                    <span class="text-danger"> {{ password_warning }} </span>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" @click="login" class="px-4">Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="d-lg-none">Register now!</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: '',
      password: '',
      password_warning: ''
    }
  },
  methods: {
    login() {
      this.$store.dispatch('auth/login', {email: this.email, password: this.password})
          .then(() => {
            this.$router.push({path: '/'});
          })
          .catch(() => {

          })
    }
  }
};
</script>
